import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify } from '@fortawesome/free-brands-svg-icons/faSpotify';
import { TypedMemo } from '../../../../../common/types';
import { isSocialPlatform } from '../../../types';
import { platformMeta, platformSolidFill } from '../../../platformMeta';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the run sheet; each part uses its own slice of it */
import styles from './Rollout.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The Spotify green of the Canvas mark (design rp.css `.chn.sp`). */
const SPOTIFY_GREEN = '#1DB954';

interface ChannelMarkProps {
  /** A social platform, or `spotify` for the Canvas mark. */
  platform: string;
  small?: boolean;
}

/** The square mark of a channel (design rollout-plan `.chn`): the platform icon on its colour. */
const ChannelMarkComponent: React.FC<ChannelMarkProps> = ({ platform, small = false }) => {
  if (platform === 'spotify') {
    return (
      <span className={clsx(styles.chn, small && styles.chnSmall)} style={{ background: SPOTIFY_GREEN }} aria-hidden>
        <FontAwesomeIcon icon={faSpotify} />
      </span>
    );
  }
  if (!isSocialPlatform(platform)) {
    return null;
  }
  const meta = platformMeta[platform];
  return (
    <span
      className={clsx(styles.chn, small && styles.chnSmall)}
      style={{ background: platformSolidFill(platform) }}
      aria-hidden
    >
      <FontAwesomeIcon icon={meta.icon} />
    </span>
  );
};

export const ChannelMark = TypedMemo(ChannelMarkComponent);
